import { TAvailByMonthResp } from '@/domain/Availability.domain';
import instance from '../Axios';
import { ApiUrls } from '@/service/constants/urls';
import { format } from 'date-fns';
import { MONTH_FORMAT_DATE } from '@/service/constants/dates';
import { replaceLightframe } from '@/service/utils/replaceLightframe';
import { newDateFromString } from '@/service/utils/getDateByTimezone';

export const getAvailabilityByMonth = (
    partnerId: string,
    trip_id: string,
    date: string
): Promise<string[]> => {
    return instance
        .post<TAvailByMonthResp>(
            ApiUrls.availability.month,
            {
                trip_id,
                month: format(newDateFromString(date), MONTH_FORMAT_DATE),
            },
            {
                params: {
                    partnerId: replaceLightframe(partnerId),
                },
            }
        )
        .then(({ data }) => data.available_dates)
        .catch(() => []);
};
